/** Types */
export const GET_FACILITIES = "GET_FACILITIES";
export const GET_FACILITIES_SUCCESS = "GET_FACILITIES_SUCCESS";
export const ADD_FACILITIES = "ADD_FACILITIES";
export const EDIT_FACILITIES = "EDIT_FACILITIES";
export const DELETE_FACILITIES = "DELETE_FACILITIES";
export const CHANGE_STATUS_FACILITIES = "CHANGE_STATUS_FACILITIES";
